export const replaceChildren = (element, newChild) => {
    element.innerHTML = '';
    element.appendChild(newChild);
};
